/**
 * The HTTP status of an error thrown by `utilities/request` on a non-2xx
 * response, or `undefined` for anything else (including the network-failure
 * case, where `request` attaches an undefined `response`).
 */
export default function httpErrorStatus(err: unknown): number | undefined {
  if (
    err instanceof Error &&
    "response" in err &&
    err.response instanceof Response
  ) {
    return err.response.status;
  }
  return undefined;
}
